import { render, staticRenderFns } from "./AmountBadge.vue?vue&type=template&id=62b0613c"
import script from "./AmountBadge.vue?vue&type=script&lang=js"
export * from "./AmountBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports